import { Box, Typography } from "@mui/material";
export default function PkCommonTitle(props) {
  const { show } = props;
  return (
    <>
      <Typography variant="h6" sx={{ pr: 2.25 }}>
        {show.name}
      </Typography>
      <Box sx={{ p: 0, pt: 1, display: "flex" }}>
        <Box
          sx={{
            mt: 0.75,
            height: "40px",
            borderLeft: 2,
            borderColor: "primary.main",
            opacity: 0.75,
          }}
        ></Box>
        <Box>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ pl: 2.5, lineHeight: 1.75 }}
          >
            {show.text}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: (theme) => theme.palette.grey[600],
              lineHeight: 1.75,
              pl: 2.5,
            }}
          >
            {show.type}
          </Typography>
        </Box>
      </Box>
    </>
  );
}
